import React, { Component } from "react";
// import classnames from "classnames";
// import "react-responsive-modal/styles.css";
// import { Modal } from "react-responsive-modal";
import Alert from "react-s-alert";
import { Modal, Image, Form } from "react-bootstrap";
import {
  // ReusableOnboardingMapButton,
  ReusableOnboardingButton,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import {
  // InputBoxComponent,
  NewInputText,
  // TextAreaReusableComponent,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  get_all_category,
  create_sub_category,
} from "../../../../store/actions/categoryActions";
import isEmpty from "../../../../store/validation/is-Empty";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { add_vendor_issues_suggestions } from "../../../../store/actions/VendorIssuesSuggestionActions/VendorIssuesSuggestionActions";

export class SuggestNewButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      title: "",
      allcategory: [],
      selected_category: "",
      category: "",
      comment: "",
      errors: [],
    };
  }

  componentDidMount() {
    const categoryId = this.props.categoryId;
    if (categoryId === "5f562c9094ac7fdf47ea1d0a") {
      this.setState({
        category: "Business Type",
        selected_category: "5f562c9094ac7fdf47ea1d0a",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d0b") {
      this.setState({
        category: "Payments Methods",
        selected_category: "5f562c9094ac7fdf47ea1d0b",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d0c") {
      this.setState({
        category: "Dress Code",
        selected_category: "5f562c9094ac7fdf47ea1d0c",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d0d") {
      this.setState({
        category: "Pets Allowed",
        selected_category: "5f562c9094ac7fdf47ea1d0d",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d0e") {
      this.setState({
        category: "Located Inside",
        selected_category: "5f562c9094ac7fdf47ea1d0e",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d10") {
      this.setState({
        category: "Health & Sanitation at Entry Point",
        selected_category: "5f562c9094ac7fdf47ea1d10",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d11") {
      this.setState({
        category: "Health & Sanitation inside Facility",
        selected_category: "5f562c9094ac7fdf47ea1d11",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d12") {
      this.setState({
        category: "Health & Sanitation with Employees",
        selected_category: "5f562c9094ac7fdf47ea1d12",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d13") {
      this.setState({
        category: "Food Handling practices",
        selected_category: "5f562c9094ac7fdf47ea1d13",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d14") {
      this.setState({
        category: "Health and Safety",
        selected_category: "5f562c9094ac7fdf47ea1d14",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d15") {
      this.setState({
        category: "Parking",
        selected_category: "5f562c9094ac7fdf47ea1d15",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d17") {
      this.setState({
        category: "Accessibility",
        selected_category: "5f562c9094ac7fdf47ea1d17",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d18") {
      this.setState({
        category: "Other Features",
        selected_category: "5f562c9094ac7fdf47ea1d18",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d19") {
      this.setState({
        category: "Services Offered",
        selected_category: "5f562c9094ac7fdf47ea1d19",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d1b") {
      this.setState({
        category: "Food Category",
        selected_category: "5f562c9094ac7fdf47ea1d1b",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d1c") {
      this.setState({
        category: "Liqours",
        selected_category: "5f562c9094ac7fdf47ea1d1c",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d1d") {
      this.setState({
        category: "Food Type",
        selected_category: "5f562c9094ac7fdf47ea1d1d",
      });
    } else if (categoryId === "5f562c9094ac7fdf47ea1d1e") {
      this.setState({
        category: "Cuisine Offered",
        selected_category: "5f562c9094ac7fdf47ea1d1e",
      });
    } else if (categoryId === "5f5723f455e36968b805b4cb") {
      this.setState({
        category: "Seating Area",
        selected_category: "5f5723f455e36968b805b4cb",
      });
    } else if (categoryId === "5fa2abe7a930bc32ce5790c7") {
      this.setState({
        category: "Point Of Sale",
        selected_category: "5fa2abe7a930bc32ce5790c7",
      });
    } else if (categoryId === "5f59f5d4471b85440d5adccc") {
      this.setState({
        category: "Allergies",
        selected_category: "5f59f5d4471b85440d5adccc",
      });
    } else if (categoryId === "5ffd80985ff032513b1353a2") {
      this.setState({
        category: "Tags Information",
        selected_category: "5ffd80985ff032513b1353a2",
      });
    } else if (categoryId === "6204d2c756deb559e7df52b5") {
      this.setState({
        category: "Health Tags",
        selected_category: "6204d2c756deb559e7df52b5",
      });
    }
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps?.categories?.all_category) &&
      !nextState.hasSetData
    ) {
      return {
        allcategory: nextProps?.categories?.all_category,
        hasSetData: true,
      };
    }
    return null;
  }

  onOpenModal = (e) => {
    e.preventDefault();
    this.setState({ open: true, errors: [] });
  };

  onCloseModal = (e) => {
    this.setState({ open: false, errors: [] });
  };

  onChange = (e) => {
    if (e.target.name === "comment") {
      let caps = e.target.value;
      caps = caps.charAt(0).toUpperCase() + caps.slice(1);
      let dataSet = caps;
      this.setState({
        [e.target.name]: dataSet,
      });
    } else {
      let data = e.target.value.split(" ");
      let newarray1 = [];
      for (let x = 0; x < data.length; x++) {
        newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
      }
      let newData = newarray1.join(" ");
      this.setState({
        [e.target.name]: newData,
      });
    }
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `${e.target.name} is required`;
    } else {
      errors[e.target.name] = "";
    }
    this.setState({
      errors: errors,
    });
  };

  onCallBackFunc = (e) => {
    this.onCloseModal();
    // Alert.success(`<h4>Your request has been Submitted</h4>`, {
    //   position: "top-right",
    //   effect: "bouncyflip",
    //   beep: true,
    //   html: true,
    //   timeout: 3000,
    //   offset: 35,
    // });
    this.setState({
      title: "",
      // category: "",
      comment: "",
      // selected_category: "",
    });
  };

  onSubmitHandler = (e) => {
    // const formData = {
    //   selected_category: this.state.selected_category,
    //   title: this.state.title,
    //   description: this.state.comment,
    //   status: "NOTAPPROVED",
    // };
    const formData = {
      type: "SUGGESTION",
      issue_title: this.state.title,
      category: this.state.selected_category,
      comment: this.state.comment,
    };
    this.props.add_vendor_issues_suggestions(
      formData,
      this.props.auth?.user?.accessToken,
      this.onCallBackFunc,
      "SUGGESTNEW"
    );
  };

  onErrorCallback = (err) => {
    Alert.error(`<h4>${err.response.data.message}</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  render() {
    const { open, errors, title, category, comment } = this.state;
    return (
      <React.Fragment>
        <AddButtonIconComponent
          buttonText="Suggest New"
          onClick={this.onOpenModal}
          fontIcon="fa fa-plus"
          colorCss="red"
        />
        {/* <Modal
          open={open}
          onClose={this.onCloseModal}
          center
          classNames={{
            overlay: "onBoarding-CustomOverlay-request-accept-cancelled",
            modal: "suggest-vendor-model-popup",
            animationIn: "onBoardingCustomEnterAnimation",
            animationOut: "onBoardingCustomLeaveAnimation",
          }}
          animationDuration={1000}
        > */}
        <Modal
          show={open}
          size="md"
          className="suggest-vendor-model-popup"
          onHide={this.onCloseModal}
          keyboard={false}
          backdrop="static"
          centered
        >
          <div>
            <div className="suggest-vendor-model-popup-header">
              <h4>Suggest New</h4>
              <Image
                src={require("../../../../assets/images/UserManagement/close.svg")}
                alt="close"
                title="close"
                onClick={this.onCloseModal}
                width="14px"
              />
              {/* <i
                class="fa fa-times"
                aria-hidden="true"
                onClick={this.onCloseModal}
              ></i> */}
            </div>
            <div className="suggest-vendor-model-popup-bodybox">
              <Form noValidate>
                <NewInputText
                  extraClass="mt-4 mb-4"
                  name="title"
                  inputType="text"
                  onChange={this.onChange}
                  onFocusOut={this.onFocusOut}
                  value={this.state.title}
                  errorText={errors.title}
                  errorTrue={
                    errors.title === "title is required" ? true : false
                  }
                  labelText="Title"
                  controlClass={
                    errors.title === "title is required"
                      ? "outlined-error-helper-text"
                      : "outlined-helperText"
                  }
                />
                <NewInputText
                  extraClass="mb-4"
                  name="category"
                  inputType="text"
                  onChange={this.onChange}
                  onFocusOut={this.onFocusOut}
                  value={this.state.category}
                  errorText={errors.category}
                  errorTrue={
                    errors.category === "category is required" ? true : false
                  }
                  labelText="Category"
                  controlClass={
                    errors.category === "category is required"
                      ? "outlined-error-helper-text"
                      : "outlined-helperText"
                  }
                  disabled={true}
                />
                <div className="col-12 p-0 mt-3 text-area-labelText-padding">
                  <NewInputText
                    extraClass="text-area-labelText-padding-two"
                    name="comment"
                    onChange={this.onChange}
                    onFocusOut={this.onFocusOut}
                    rows="6"
                    multiline={true}
                    value={this.state.comment}
                    errorText={errors.comment}
                    errorTrue={
                      errors.comment === "comment is required" ? true : false
                    }
                    labelText="Comment"
                    controlClass={
                      errors.comment === "comment is required"
                        ? "outlined-error-helper-text"
                        : "outlined-helperText "
                    }
                  />
                </div>
              </Form>
              <div className="d-flex mt-3">
                <ReusableOnboardingButton
                  buttonText="Cancel"
                  buttonTitle="Cancel Button"
                  buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                  onClick={this.onCloseModal}
                />
                <ReusableOnboardingButton
                  buttonText="Submit"
                  buttonTitle="Submit Button"
                  buttonClass={
                    title === "" || category === "" || comment === ""
                      ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                      : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                  }
                  disabled={
                    title === "" || category === "" || comment === ""
                      ? true
                      : false
                  }
                  onClick={this.onSubmitHandler}
                />
              </div>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  categories: state.categories,
});

export default connect(mapStateToProps, {
  get_all_category,
  create_sub_category,
  add_vendor_issues_suggestions,
})(withRouter(SuggestNewButton));
